export const PIN_LENGTH = 6;

const ARABIC_INDIC_DIGITS = '٠١٢٣٤٥٦٧٨٩';
const EASTERN_ARABIC_DIGITS = '۰۱۲۳۴۵۶۷۸۹';
const COMMON_PINS = new Set(['000000', '111111', '123456', '654321', '112233']);

/**
 * Normalizes numeric input for the browser only. It neither persists nor logs a PIN.
 * Arabic and Persian digits are accepted so the setting and login screens behave alike.
 */
export function normalizePin(value) {
    return Array.from(typeof value === 'string' ? value : '')
        .map(character => {
        const arabicIndex = ARABIC_INDIC_DIGITS.indexOf(character);
        if (arabicIndex >= 0)
            return String(arabicIndex);
        const easternIndex = EASTERN_ARABIC_DIGITS.indexOf(character);
        if (easternIndex >= 0)
            return String(easternIndex);
        return character;
    })
        .join('')
        .replace(/[^0-9]/g, '');
}

function isSimpleSequence(value) {
    if (value.length !== PIN_LENGTH)
        return false;
    const digits = Array.from(value, Number);
    return digits.every((digit, index) => index === 0 || digit - digits[index - 1] === 1)
        || digits.every((digit, index) => index === 0 || digit - digits[index - 1] === -1);
}

/**
 * Client-side setting guidance only. Server-side validation and rate limiting remain
 * the authority for every login attempt.
 */
export function evaluatePin(pin) {
    const normalized = normalizePin(pin);
    const hasRequiredLength = normalized.length === PIN_LENGTH;
    const isRepeated = hasRequiredLength && /^([0-9])\1+$/.test(normalized);
    const isSequence = hasRequiredLength && isSimpleSequence(normalized);
    const isCommon = hasRequiredLength && COMMON_PINS.has(normalized);
    let message = '';
    if (!hasRequiredLength)
        message = 'أدخل PIN من 6 أرقام';
    else if (isRepeated)
        message = 'اختر PIN لا يكرر الرقم نفسه';
    else if (isSequence)
        message = 'اختر PIN غير متسلسل';
    else if (isCommon)
        message = 'اختر PIN غير شائع';
    return {
        normalized,
        hasRequiredLength,
        isRepeated,
        isSequence,
        isCommon,
        eligible: hasRequiredLength && !isRepeated && !isSequence && !isCommon,
        message,
    };
}
